<template>
  <!-- 商品详情 -->
  <div class="IA_goodsDetails">
    <van-nav-bar :title="'商品详情'"
                 left-text
                 left-arrow
                 @click-left="onClickLeft"
                 :fixed="true" />
    <div class="content">
      <div class="goods_Introduction">
        <van-swipe :autoplay="3000"
                   @change="onChangeSW">
          <van-swipe-item v-for="(image, index) in swipeImgs"
                          :key="index"
                          @click="showMoreImg">
            <img v-lazy="image.picurl" />
          </van-swipe-item>
          <template #indicator>
            <div class="custom-indicator">{{ current + 1 }}/{{swipeImgs.length}}</div>
          </template>
        </van-swipe>
        <div class="jiage">
          <div class="ji_left">
            <span class="txt">单价：</span>
            {{baseinfo.ptcredit}}
            <span class="txt">积分</span>
          </div>
          <div class="ji_right">
            <span class="txt">剩：</span>
            {{baseinfo.balance}}
            <span class="txt">{{baseinfo.ptunit}}</span>
          </div>
        </div>
        <div class="goods_title">
          <!-- <van-tag color="#fd0088">甄选</van-tag> -->
          <span class="depict">{{baseinfo.ptname_fullname}}</span>
        </div>
        <van-divider class="desc_divider"
                     :hairline="false">商品详情</van-divider>
        <div class="goods_details_imgs">
          <van-image v-for="(img,idx) in detailsImgs"
                     :key="idx"
                     lazy-load
                     :scale="1"
                     :width="'100%'"
                     :src="img.picurl?img.picurl:require('@assets/img/loading-error.png')"
                     @click="showDetailsImg(img.picurl)"></van-image>
        </div>
      </div>
      <van-goods-action>
        <!-- <van-goods-action-icon icon="like-o"
                               text="收藏"
                               @click="onClickShouCang" /> -->
        <van-goods-action-button type="danger"
                                 color="#fd0088"
                                 text="立即兑换"
                                 @click="onClickDuiHuang" />
      </van-goods-action>
    </div>
    <van-popup v-model="showSku"
               class="sku_popup"
               round
               closeable
               close-icon="close"
               position="bottom">
      <!-- :style="{ height: '50%' }" -->
      <div class="sku_body">
        <div class="sku_head">
          <van-image :src="swipeImgs.length>0?swipeImgs[0].picurl:require('@assets/img/loading-error.png')"
                     :scale="1"
                     :width="'35%'"></van-image>
          <div class="jiage">
            {{baseinfo.ptcredit}}
            <span class="txt">积分</span>
          </div>
        </div>
        <div class="num">
          <div class="label">购买数量</div>
          <van-stepper v-model="quantity"
                       integer
                       min="1" />
        </div>
        <div class="payment">
          <div class="label">支付方式</div>
          <div class="pay_type">{{calculatePoints}}积分</div>
        </div>
        <div class="footer">
          <van-button round
                      size="small"
                      color="#fd0088"
                      @click="onBuyClicked">确定兑换</van-button>
        </div>
      </div>
    </van-popup>

  </div>

</template>

<script>
import { Lazyload, Dialog, Toast, ImagePreview } from 'vant';
import { getCreditProductDetailInfo, empExchangeProduct } from '@api/integral.js'
export default {
  data () {
    const userInfo = localStorage.userInfo
      ? JSON.parse(localStorage.userInfo)
      : {}
    const goodsId = this.$route.query.goodsId
    return {
      userInfo,
      goodsId,
      current: 0, // 轮播图下标
      swipeImgs: [], // 轮播图
      baseinfo: {},
      detailsImgs: [], // 详情图
      showSku: false,
      quantity: 1,
    }
  },
  computed: {
    // 所需积分
    calculatePoints () {
      return this.baseinfo.ptcredit * this.quantity
    }
  },
  created () {
    this.goodsId = this.$route.query.goodsId
    this.getCreditProductDetailInfoData()
  },
  methods: {
    // 详情的图片
    showDetailsImg (picurl) {
      if (picurl)
      {
        ImagePreview([picurl])
      }
    },
    // 获取某个商品的详细
    getCreditProductDetailInfoData () {
      getCreditProductDetailInfo({
        autoid: this.goodsId,
        username: this.userInfo.username
      }).then(res => {
        this.baseinfo = res.baseinfo[0] ? res.baseinfo[0] : {}
        this.swipeImgs = res.piclist1
        this.detailsImgs = res.piclist2 || []
      })
    },
    // 轮播图预览
    showMoreImg () {
      if (this.swipeImgs.length > 0)
      {
        let imgs = this.swipeImgs.map(it => { return it.picurl })
        ImagePreview({
          images: imgs,
          startPosition: this.current,
          closeable: true
        })
      }
    },
    // 轮播图改变事件
    onChangeSW (index) {
      this.current = index;
    },
    // 确定兑换
    onBuyClicked () {
      let params = {
        username: this.userInfo.username,
        data: [
          {
            mautoid: this.baseinfo.autoid,
            outnum: this.quantity,
            ptcredit: this.baseinfo.ptcredit
          }
        ]
      }
      Dialog.confirm({
        title: this.$t('module.systemhint'),
        message: '您确定要兑换该商品吗？',
      }).then(() => {
        empExchangeProduct(params).then(res => {
          if (res.data[0].info)
          {
            Toast.fail(res.data[0].info);
          } else
          {
            // Toast.success(this.$t('module.submitScu') + '具体的兑换时间和地点请关注HR中心发布的通知');
            Dialog.alert({
              title: this.$t('module.submitScu'),
              message: '具体的兑换时间和地点请关注HR中心发布的通知',
            }).then(() => {
              this.showSku = false
            });
          }
        })
      }).catch(() => {
        // on cancel
      });
    },
    // 收藏
    onClickShouCang () {

    },
    // 立即兑换
    onClickDuiHuang () {
      if (this.baseinfo.balance <= 0)
      {
        Dialog.alert({
          title: this.$t('module.systemhint'),
          message: '库存不足，暂时无法兑换！',
        }).then(() => {

        });
        return
      }
      this.showSku = true
    },
    // 返回
    onClickLeft () {
      this.$router.push({
        path: '/pointsExchange',
        query: { from: this.$route.query.from }
      })
    },
  }

}
</script>

<style lang="less" scoped>
.IA_goodsDetails {
  height: 100vh;
  overflow: hidden;
  .van-nav-bar {
    background: #2b8df0;
    /deep/ .van-nav-bar__left {
      .van-icon {
        color: #fff;
      }
    }
    /deep/.van-nav-bar__title {
      color: #fff;
      font-size: 36px;
      font-family: Source Han Sans CN;
    }
  }
  .content {
    // overflow: auto;
    margin-top: 1.22667rem;
    height: calc(100% - 92px);
    .goods_Introduction {
      height: calc(100% - 100px);
      overflow-y: auto;
      .van-swipe {
        height: 50%;
        .van-swipe-item {
          img {
            width: 100%;
            height: 100%;
          }
        }
        .custom-indicator {
          position: absolute;
          right: 10px;
          bottom: 10px;
          padding: 4px 18px;
          font-size: 24px;
          color: #ffffff;
          background: #979797;
          border-radius: 24px;
        }
      }
      .jiage {
        padding: 20px;
        margin-bottom: 20px;
        width: 100%;
        font-size: 50px;
        background: #ffffff;
        font-weight: bold;
        display: flex;
        justify-content: space-between;
        .ji_left {
          color: #fd0088;
          .txt {
            font-size: 24px;
          }
        }
        .ji_right {
          color: #ff976a;
          .txt {
            font-size: 24px;
          }
        }
      }
      .goods_title {
        padding: 20px;
        background: #ffffff;
        font-size: 36px;
        line-height: 1.5;
      }
      .desc_divider {
        padding: 0 20px;
        font-size: 32px;
      }
      .desc_divider::before,
      .desc_divider::after {
        border-width: 2px;
      }
      .goods_details_imgs {
        padding: 20px;
        background: #ffffff;
        display: flex;
        flex-direction: column;
      }
    }
    .van-goods-action {
      height: 100px;
      justify-content: flex-end;
      .van-button {
        flex: none;
        width: 60%;
      }
    }
  }
  .DuiHuang_sku {
    /deep/.van-sku-actions {
      .van-button {
        background: #fd0088;
      }
    }
  }
  .sku_popup {
    .sku_body {
      position: relative;
      height: 100%;
      padding: 40px;
      .sku_head {
        display: flex;
        justify-content: flex-start;
        align-items: flex-end;
        .jiage {
          margin-left: 20px;
          font-size: 40px;
          color: #fd0088;
          text-align: left;
          background: #ffffff;
          .txt {
            font-size: 28px;
          }
        }
      }
      .num {
        margin: 30px 0;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .label {
          font-size: 30px;
        }
        /deep/.van-stepper {
          .van-stepper__input {
            width: 100px;
          }
        }
      }
      .payment {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        margin-bottom: 60px;
        .label {
          font-size: 30px;
        }
        .pay_type {
          margin-top: 10px;
          padding: 10px 40px;
          display: inline-flex;
          font-size: 24px;
          color: #fd0088;
          border-radius: 30px;
          background: #fae7ee;
        }
      }
      .footer {
        display: flex;
        width: 100%;
        // position: absolute;
        // bottom: 40px;
        // left: 0;
        // padding: 0 40px;
        .van-button {
          width: 100%;
          font-size: 28px;
        }
      }
    }
  }
}
</style>